// Parse config

let parseConfig: Parse.Config | undefined;

async function fetchParseConfig(): Promise<Parse.Config | undefined> {
    try {
        return await Parse.Config.get();
    } catch (e: any) {
        if (
            e?.message &&
            typeof e.message === 'string' &&
            e.message.toLowerCase().includes('session token')
        ) {
            try {
                await Parse.User.logOut();
            } catch (e) {
                console.error('Error logging out user', e);
            }
            window.location.reload();
        } else {
            console.error('Failed to fetch Parse config', e);
        }
        return undefined;
    }
}

// The SDK returns an empty Config, not null, when nothing is persisted.
function getCachedParseConfig(): Parse.Config | undefined {
    try {
        const cached = Parse.Config.current() as Parse.Config & {
            attributes?: Record<string, unknown>;
        };
        return Object.keys(cached?.attributes ?? {}).length
            ? cached
            : undefined;
    } catch (e) {
        return undefined;
    }
}

// On a cached boot the background fetch only persists the fresh config for the
// next load; parseConfig stays one snapshot so readers agree within a session.
export async function initParseConfig(): Promise<void> {
    const cached = getCachedParseConfig();
    const fresh = fetchParseConfig();
    if (cached) {
        parseConfig = cached;
        return;
    }
    parseConfig = await fresh;
}

export const getParseConfig = (key: string): string => {
    if (!parseConfig) {
        return '';
    }
    return parseConfig.get(key);
};
